import styled, { blockProps } from '@tanium/react-emotion';
import { css } from '@tanium/style-system';
import {
  Border,
  BorderFocus,
  BorderInvalid,
  FillDisabled,
  ShadowFocus,
  Fill as TextInputFill,
  UnitLabelBackground,
  UnitLabelText,
} from './themeDefinitions';

export const UnitInputContainer = styled('div', {
  shouldForwardProp: blockProps(['disabled', 'invalid', 'width']),
})<{
  disabled?: boolean;
  invalid?: boolean;
  width?: string | number | undefined;
}>(({ disabled, invalid, width }) =>
  css({
    width: width ?? '200px',
    display: 'inline-flex',
    borderStyle: 'solid',
    borderWidth: '1px',
    borderRadius: '4px',
    justifyContent: 'space-between',
    backgroundColor: disabled ? FillDisabled : TextInputFill,
    borderColor: invalid ? BorderInvalid : Border,
    ':focus-within': {
      borderColor: BorderFocus,
      boxShadow: ShadowFocus,
      outlineColor: 'transparent',
      outlineStyle: 'inherit',
    },
  }),
);

export const UnitLabel = styled('div')(
  css({
    fontSize: '14px',
    display: 'flex',
    borderRadius: '4px',
    alignItems: 'center',
    padding: '0 8px',
    backgroundColor: UnitLabelBackground,
    color: UnitLabelText,
    margin: '3px',
    userSelect: 'none',
    whiteSpace: 'nowrap',
  }),
);
